import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';
import { Button, Card, Col, Row } from 'react-bootstrap';

import IconButton from '@components/Button/IconButton';
import { ReactComponent as ArrowIcon } from '@assets/images/natera/arrow-right.svg';

import patternImage from '@assets/images/natera/x-pattern-colors234x316.png';

import LoadingIndicator from '@components/LoadingIndicator/LoadingIndicator';
import { IS_NATERA } from '@constants/constants';
import useAuth from '@hooks/useAuth';

export default function PortalEntry() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, onLogin } = useAuth();

  const redirectUrl = location.state?.pathname;

  useEffect(() => {
    // Redirect to login page automatically
    if (redirectUrl && !isLoggedIn) {
      onLogin(redirectUrl);
    }
  }, [redirectUrl, onLogin, isLoggedIn]);

  if (redirectUrl && !isLoggedIn) {
    return <LoadingIndicator />;
  }

  return (
    <div data-testid='login_page' className='natera-portal-entry-page'>
      <main className='natera-login-page-wrapper'>
        <img className='pattern' src={patternImage} alt='Decorative Pattern' />
        <div className='login-page-content'>
          <Row>
            <Col>
              <h1 className='login-page-title'>Welcome</h1>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={7} xxl={6}>
              <Card className='login-card'>
                <Card.Body>
                  <h2 className='h4'>
                    Natera's <span className='d-block d-sm-inline'>Provider Portal</span>
                  </h2>
                  <p className='text-secondary'>
                    Order tests, check on your testing results, and download your testing reports.
                  </p>
                  <IconButton
                    variant='cta'
                    className='d-flex justify-content-center align-items-center new-order-btn'
                    onClick={() => onLogin()}
                    data-testid='loginBtn'
                  >
                    Login to Portal
                    <ArrowIcon height={10} className='ms-2' />
                  </IconButton>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {!IS_NATERA && (
            <Row>
              <Col>
                <Button
                  variant='outline-secondary'
                  size='sm'
                  className='mt-3'
                  onClick={() => navigate('/signup')}
                  data-testid='signup-button'
                >
                  Sign up for an account
                </Button>
              </Col>
            </Row>
          )}
        </div>
      </main>
    </div>
  );
}
